import React from "react";

export default function TutorialButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        backgroundColor: "rgb(77, 65, 133)",
        color: "white",
        position: "absolute",
        left: "12px",
        top: "90px",
        zIndex: 20000,
        borderRadius: "999px",
        width: "63px",
        height: "63px",
        border: "none",
        cursor: "pointer",
        fontSize: "35px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      }}
      aria-label="Start tutorial"
      title="Tutorial"
    >
      ?
    </button>
  );
}